"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AlpineSimpleProductFinder;
function AlpineSimpleProductFinder() {
    return Alpine.data('simpleProductFinder', function () { return ({
        API_URL: '/graphql',
        loading: true,
        products: [],
        selectedCategory: '',
        selectedIndustry: '',
        init: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('Simple Product Finder: Initializing');
                            return [4 /*yield*/, this.fetchAllProducts()];
                        case 1:
                            _a.sent();
                            this.loading = false;
                            return [2 /*return*/];
                    }
                });
            });
        },
        fetchAllProducts: function () {
            return __awaiter(this, void 0, void 0, function () {
                var allProducts, filteredProducts, error_1;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('Simple Product Finder: Fetching all products');
                            this.loading = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.graphQLRequest(this.graphQLQueryAllProducts)];
                        case 2:
                            allProducts = _a.sent();
                            if (allProducts && allProducts.length > 0) {
                                console.log("Simple Product Finder: Found ".concat(allProducts.length, " products"));
                                filteredProducts = allProducts;
                                if (this.selectedCategory) {
                                    filteredProducts = filteredProducts.filter(function (product) {
                                        var _a, _b;
                                        return ((_b = (_a = product.taxProductCategories) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.some(function (category) { return (_this.decodeTermId(category.id) === _this.selectedCategory); }));
                                    });
                                    console.log("Simple Product Finder: Filtered to ".concat(filteredProducts.length, " products for category ").concat(this.selectedCategory));
                                }
                                if (this.selectedIndustry) {
                                    filteredProducts = filteredProducts.filter(function (product) {
                                        var _a, _b;
                                        return ((_b = (_a = product.taxIndustries) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.some(function (industry) { return (_this.decodeTermId(industry.id) === _this.selectedIndustry); }));
                                    });
                                    console.log("Simple Product Finder: Filtered to ".concat(filteredProducts.length, " products for industry ").concat(this.selectedIndustry));
                                }
                                this.products = filteredProducts;
                            }
                            else {
                                console.log('Simple Product Finder: No products found');
                                this.products = [];
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            console.error('Simple Product Finder: Error fetching products', error_1);
                            this.products = [];
                            return [3 /*break*/, 4];
                        case 4:
                            this.loading = false;
                            return [2 /*return*/];
                    }
                });
            });
        },
        filterByCategory: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('Simple Product Finder: Filtering by category:', this.selectedCategory);
                            return [4 /*yield*/, this.fetchAllProducts()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        filterByIndustry: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('Simple Product Finder: Filtering by industry:', this.selectedIndustry);
                            return [4 /*yield*/, this.fetchAllProducts()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        decodeTermId: function (encodedId) {
            // Decode base64 encoded ID like "dGVybToxMA==" to numeric ID like "10"
            try {
                var decoded = atob(encodedId);
                var match = decoded.match(/term:(\d+)/);
                return match ? match[1] : null;
            }
            catch (error) {
                console.error('Error decoding term ID:', error);
                return null;
            }
        },
        graphQLRequest: function (query) {
            return __awaiter(this, void 0, void 0, function () {
                var response, result, error_2;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 3, , 4]);
                            return [4 /*yield*/, fetch(this.API_URL, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({ query: query }),
                                })];
                        case 1:
                            response = _c.sent();
                            return [4 /*yield*/, response.json()];
                        case 2:
                            result = _c.sent();
                            if (result.errors) {
                                console.error('GraphQL errors:', result.errors);
                                return [2 /*return*/, null];
                            }
                            return [2 /*return*/, ((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.contentNodes) === null || _b === void 0 ? void 0 : _b.nodes) || []];
                        case 3:
                            error_2 = _c.sent();
                            console.error('GraphQL request failed:', error_2);
                            return [2 /*return*/, null];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        get graphQLQueryAllProducts() {
            return "query getAllProducts {\n        contentNodes(\n          where: {\n            contentTypes: PRODUCT\n          }\n          first: 100\n        ) {\n          nodes {\n            ... on Product {\n              databaseId\n              title\n              slug\n              uri\n              featuredImage {\n                node {\n                  sourceUrl\n                  srcSet\n                }\n              }\n              taxProductCategories {\n                nodes {\n                  name\n                  id\n                }\n              }\n              taxIndustries {\n                nodes {\n                  name\n                  id\n                }\n              }\n            }\n          }\n        }\n      }";
        },
    }); });
}
